import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkItemLaneComponent } from 'components/work-item-lane-list/work-item-lane/work-item-lane.component';
import { WorkItemWidgetModule } from 'components/work-item-lane-list/work-item-lane/work-item-widget/work-item-widget.module';

@NgModule({
  imports: [
    CommonModule,
    WorkItemWidgetModule
  ],
  declarations: [
    WorkItemLaneComponent
  ],
  exports: [
    WorkItemLaneComponent
  ]
})
export class WorkItemLaneModule {}
